import { getSerializer } from '@shared/serializers/serializer';

export const authentication = {
  type: 'auth',
  attributes: ['detail', 'password', 'token', 'resetToken']
};

export const AuthenticationSerializer = getSerializer(authentication);
